import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  Square,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RiDownload2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Layout from "../../../components/student/Layout/layout";
import AddVoucher from "../../../containers/student/models/add-voucher";
import VideoPreview from "../../../containers/student/video/videoPreview";
import axiosInstance from "../../../helpers/api";
import { getVideosByChapterIdRequest } from "../../../modules/students-modules/videos/Actions";

const StudentVideo = (props) => {
  const [selectedData, setSelectedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [playBack, setPlayBack] = useState("");
  const baseUrl = "https://asquera.com/asquera";
  const [getSearchParams, setSearchParams] = useSearchParams();
  const video_id = getSearchParams.get("video");
  const chapter_name = getSearchParams.get("name");
  const params = useParams();
  const dispatch = useDispatch();

  const chapterVideos = useSelector(
    (state) => state.chapterVideos.chapterVideos
  );
  const isLoading = useSelector((state) => state.chapterVideos.isLoading);

  const getVideoData = async (id) => {
    const res = await axiosInstance.get(`/students/videos/otp/${id}`);
    await setOtp(res?.data?.otp);
    await setPlayBack(res?.data?.playbackInfo);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (video_id && chapterVideos?.length > 0) {
      const filteredData = chapterVideos?.find((data) => data?.id == video_id);
      if (filteredData) {
        setSelectedData(filteredData);
      }
    }
  }, [video_id, chapterVideos]);

  useEffect(() => {
    if (selectedData?.id) {
      if (selectedData?.video_type == 1) getVideoData(selectedData?.id);
    }
  }, [selectedData]);

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container
        maxW="container.2xl"
        px={{ base: 2, md: 4 }}
        p={{ base: 2, md: 4, lg: 6, sm: 6 }}
      >
        <VStack spacing={6} w="100%" alignItems="flex-start" mt="20px">
          <Breadcrumb fontSize="sm">
            <BreadcrumbItem>
              <Link to="/videos/sections">
                <Text>Video</Text>
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <Text textTransform="capitalize">{chapter_name}</Text>
            </BreadcrumbItem>
          </Breadcrumb>

          {chapterVideos?.length === 0 && (
            <Heading
              as="h6"
              color="main_1"
              textAlign="center"
              w="100%"
              fontSize="lg"
            >
              You Didn't pay for this chapter
              <a
                href="https://wa.me/+201025830160"
                style={{ textDecoration: "underline" }}
                target="_blank"
                rel="noreferrer"
              >
                , Connect with the assistant!
              </a>
            </Heading>
          )}

          <Box w="100%">
            {/* Video Player Section */}
            {selectedData?.url == "no" ? (
              <>
                <Heading>Coming Soon</Heading>
              </>
            ) : (
              chapterVideos?.length > 0 &&
              selectedData && (
                <VStack spacing="6" alignItems="flex-start" w="100%">
                  <VideoPreview
                    data={selectedData}
                    loading={loading}
                    otp={otp}
                    playBack={playBack}
                  />
                  {/* Video Materials */}
                  {selectedData?.files?.length > 0 && (
                    <VStack
                      w="100%"
                      alignItems="flex-start"
                      color="main_1"
                      spacing="4"
                    >
                      <Text
                        fontSize={{ base: "lg", md: "xl" }}
                        fontWeight="500"
                      >
                        Video materials
                      </Text>
                      <Flex w="100%" flexWrap="wrap" gap="3">
                        {selectedData?.files?.map((val, idx) => (
                          <HStack
                            key={idx}
                            w={{ base: "100%", sm: "48%", md: "31.5%" }}
                            h="60px"
                            bg="gray.50"
                            justify="space-between"
                            borderRadius="md"
                            p="3"
                            position="relative"
                            transition="all 0.2s"
                            _hover={{ bg: "gray.100" }}
                          >
                            <Text fontSize="sm">File title</Text>
                            <Square
                              size="32px"
                              bg="main_1"
                              color="white"
                              borderRadius="md"
                            >
                              <Icon as={RiDownload2Line} />
                            </Square>
                            <a
                              href={`${baseUrl}/${val?.file}`}
                              download
                              style={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                              }}
                              target="_blank"
                            />
                          </HStack>
                        ))}
                      </Flex>
                    </VStack>
                  )}
                </VStack>
              )
            )}
          </Box>
        </VStack>
      </Container>
      <AddVoucher video_id={selectedData?.id} />
    </Layout>
  );
};

export default StudentVideo;
